import { useRef } from "react";
import { useNavigate, useParams } from "react-router";
// cmp
import GloginSelect from "./GloginSelect";
// hooks
import useStorage, { StorageKeys } from "../../hooks/useStorage";
// contexts
import { useUserData } from "../../context/UserDataContext";
// services
import { Storage } from "../../services/storage";
// types
import type { ComponentRef } from "react";
import type { UserId } from "../../types/user";

type RouteParams = {
	userId?: UserId;
};

const SupportUserSearchCmp = () => {
	const refGloginSelect = useRef<ComponentRef<typeof GloginSelect>>(null);
	const params = useParams<RouteParams>();

	const navigate = useNavigate();

	const { ready } = useUserData();
	const [supportUserId] = useStorage(StorageKeys.supportUserId);

	const handleClearSelectedUser = () => {
		refGloginSelect.current?.fetchGlogins();
		Storage.remove(StorageKeys.supportUserId);
		void navigate("/support/users");
	};

	const handleSelectedUserChanged = (value) => {
		Storage.set(StorageKeys.supportUserId, value.id);
		void navigate(`/support/users/${value.id}`);
	};

	if (!ready) {
		return null;
	}

	return (
		<GloginSelect
			ref={refGloginSelect}
			userId={params.userId ?? supportUserId ?? undefined}
			onSelectedUserChanged={handleSelectedUserChanged}
			onClear={handleClearSelectedUser}
		/>
	);
};

export default SupportUserSearchCmp;
